import { createReducer } from "reduxsauce";

import importer from "common/importer";

const { INITIAL_STATE } = importer("Stores/Loyalty/InitialState", null);
const { LoyaltyDetailsTypes } = importer("Stores/Loyalty/Actions", null);

const getLoyaltyDetailsLoading = (state) => ({
  ...state,
  getLoyaltyDetailsLoading: true,
  getLoyaltyDetailsSuccess: null,
  getLoyaltyDetailsFailure: null
});
const getLoyaltyDetailsSuccess = (state, { res }) => ({
  ...state,
  getLoyaltyDetails: res,
  getLoyaltyDetailsLoading: false,
  getLoyaltyDetailsSuccess: res,
  getLoyaltyDetailsFailure: null
});

const getLoyaltyDetailsFailure = (state, { error }) => ({
  ...state,
  getLoyaltyDetailsLoading: false,
  getLoyaltyDetailsSuccess: null,
  getLoyaltyDetailsFailure: error
});
const getLoyaltyActivityLoading = (state) => ({
  ...state,
  getLoyaltyActivityLoading: true,
  getLoyaltyActivitySuccess: null,
  getLoyaltyActivityFailure: null
});
const getLoyaltyActivitySuccess = (state, { res }) => ({
  ...state,
  getLoyaltyActivity: res,
  getLoyaltyActivityLoading: false,
  getLoyaltyActivitySuccess: res,
  getLoyaltyActivityFailure: null
});

const getLoyaltyActivityFailure = (state, { error }) => ({
  ...state,
  getLoyaltyActivityLoading: false,
  getLoyaltyActivitySuccess: null,
  getLoyaltyActivityFailure: error
});
const cleanLoyaltyDetailsState = (state) => ({
  ...state,
  getLoyaltyDetails: null,
  getLoyaltyDetailsSuccess: null,
  getLoyaltyActivity: null,
  getLoyaltyActivitySuccess: null
});

const cleanLoyaltyPromotionsState = (state) => ({
  ...state,
  getLoyaltyPromotions: null,
  getLoyaltyPromotionsSuccess: null,
  activateLoyaltyPromotions: null,
  activateLoyaltyPromotionsSuccess: null
});

const getLoyaltyConstantLoading = (state) => ({
  ...state,
  getLoyaltyConstantLoading: true,
  getLoyaltyConstantSuccess: null,
  getLoyaltyConstantFailure: null
});

const getLoyaltyConstantSuccess = (state, { res }) => ({
  ...state,
  getLoyaltyConstant: res,
  getLoyaltyConstantLoading: false,
  getLoyaltyConstantSuccess: res,
  getLoyaltyConstantFailure: null
});

const getLoyaltyConstantFailure = (state, { error }) => ({
  ...state,
  getLoyaltyConstantLoading: false,
  getLoyaltyConstantSuccess: null,
  getLoyaltyConstantFailure: error
});

const redeemRewardsLoading = (state) => ({
  ...state,
  redeemRewardsLoading: true,
  redeemRewardsSuccess: null,
  redeemRewardsFailure: null
});

const redeemRewardsSuccess = (state, { res }) => ({
  ...state,
  redeemRewards: res,
  redeemRewardsLoading: false,
  redeemRewardsSuccess: true,
  redeemRewardsFailure: null
});

const redeemRewardsFailure = (state, { error }) => ({
  ...state,
  redeemRewards: null,
  redeemRewardsLoading: false,
  redeemRewardsSuccess: false,
  redeemRewardsFailure: error
});

const redeemRewardsStatusCheckLoading = (state) => ({
  ...state,
  redeemRewardsStatusCheckLoading: true,
  redeemRewardsStatusCheckSuccess: null,
  redeemRewardsStatusCheckFailure: null
});

const redeemRewardsStatusCheckSuccess = (state, { res }) => ({
  ...state,
  redeemRewardsStatusCheck: res,
  redeemRewardsStatusCheckLoading: false,
  redeemRewardsStatusCheckSuccess: true,
  redeemRewardsStatusCheckFailure: null
});

const redeemRewardsStatusCheckFailure = (state, { error }) => ({
  ...state,
  redeemRewardsStatusCheck: null,
  redeemRewardsStatusCheckLoading: false,
  redeemRewardsStatusCheckSuccess: false,
  redeemRewardsStatusCheckFailure: error
});

const getLoyaltyPromotionsLoading = (state) => ({
  ...state,
  getLoyaltyPromotions: null,
  getLoyaltyPromotionsLoading: true,
  getLoyaltyPromotionsSuccess: null,
  getLoyaltyPromotionsFailure: null
});

const getLoyaltyPromotionsSuccess = (state, { res }) => ({
  ...state,
  getLoyaltyPromotions: res,
  getLoyaltyPromotionsLoading: false,
  getLoyaltyPromotionsSuccess: res,
  getLoyaltyPromotionsFailure: null
});

const getLoyaltyPromotionsFailure = (state, { error }) => ({
  ...state,
  getLoyaltyPromotions: null,
  getLoyaltyPromotionsLoading: false,
  getLoyaltyPromotionsSuccess: null,
  getLoyaltyPromotionsFailure: error
});

const activateLoyaltyPromotionsLoading = (state) => ({
  ...state,
  activateLoyaltyPromotions: null,
  activateLoyaltyPromotionsLoading: true,
  activateLoyaltyPromotionsSuccess: null,
  activateLoyaltyPromotionsFailure: null
});

const activateLoyaltyPromotionsSuccess = (state, { res, donorSfid }) => ({
  ...state,
  activateLoyaltyPromotions: res,
  activateLoyaltyPromotionsLoading: false,
  activateLoyaltyPromotionsSuccess: { res, donorSfid },
  activateLoyaltyPromotionsFailure: null
});

const activateLoyaltyPromotionsFailure = (state, { error }) => ({
  ...state,
  activateLoyaltyPromotions: null,
  activateLoyaltyPromotionsLoading: false,
  activateLoyaltyPromotionsSuccess: null,
  activateLoyaltyPromotionsFailure: error
});

const getLoyaltyGameDataLoading = (state) => ({
  ...state,
  getLoyaltyGameDataLoading: true,
  getLoyaltyGameDataSuccess: null,
  getLoyaltyGameDataFailure: null
});

const getLoyaltyGameDataSuccess = (state, { res }) => ({
  ...state,
  getLoyaltyGameDataLoading: false,
  getLoyaltyGameDataSuccess: res?.data,
  getLoyaltyGameDataFailure: null
});

const getLoyaltyGameDataFailure = (state, { error }) => ({
  ...state,
  getLoyaltyGameDataLoading: false,
  getLoyaltyGameDataSuccess: null,
  getLoyaltyGameDataFailure: error
});

const updateLoyaltyGameDataLoading = (state) => ({
  ...state,
  updateLoyaltyGameDataLoading: true,
  updateLoyaltyGameDataSuccess: null,
  updateLoyaltyGameDataFailure: null
});

const updateLoyaltyGameDataSuccess = (state, { res }) => ({
  ...state,
  updateLoyaltyGameDataLoading: false,
  updateLoyaltyGameDataSuccess: res?.data,
  updateLoyaltyGameDataFailure: null
});

const updateLoyaltyGameDataFailure = (state, { error }) => ({
  ...state,
  updateLoyaltyGameDataLoading: false,
  updateLoyaltyGameDataSuccess: null,
  updateLoyaltyGameDataFailure: error
});

export const reducer = createReducer(INITIAL_STATE, {
  [LoyaltyDetailsTypes.GET_LOYALTY_DETAILS_LOADING]: getLoyaltyDetailsLoading,
  [LoyaltyDetailsTypes.GET_LOYALTY_DETAILS_SUCCESS]: getLoyaltyDetailsSuccess,
  [LoyaltyDetailsTypes.GET_LOYALTY_DETAILS_FAILURE]: getLoyaltyDetailsFailure,

  [LoyaltyDetailsTypes.GET_LOYALTY_ACTIVITY_LOADING]: getLoyaltyActivityLoading,
  [LoyaltyDetailsTypes.GET_LOYALTY_ACTIVITY_SUCCESS]: getLoyaltyActivitySuccess,
  [LoyaltyDetailsTypes.GET_LOYALTY_ACTIVITY_FAILURE]: getLoyaltyActivityFailure,

  [LoyaltyDetailsTypes.GET_LOYALTY_CONSTANT_LOADING]: getLoyaltyConstantLoading,
  [LoyaltyDetailsTypes.GET_LOYALTY_CONSTANT_SUCCESS]: getLoyaltyConstantSuccess,
  [LoyaltyDetailsTypes.GET_LOYALTY_CONSTANT_FAILURE]: getLoyaltyConstantFailure,

  [LoyaltyDetailsTypes.REDEEM_REWARDS_LOADING]: redeemRewardsLoading,
  [LoyaltyDetailsTypes.REDEEM_REWARDS_SUCCESS]: redeemRewardsSuccess,
  [LoyaltyDetailsTypes.REDEEM_REWARDS_FAILURE]: redeemRewardsFailure,

  [LoyaltyDetailsTypes.REDEEM_REWARDS_STATUS_CHECK_LOADING]: redeemRewardsStatusCheckLoading,
  [LoyaltyDetailsTypes.REDEEM_REWARDS_STATUS_CHECK_SUCCESS]: redeemRewardsStatusCheckSuccess,
  [LoyaltyDetailsTypes.REDEEM_REWARDS_STATUS_CHECK_FAILURE]: redeemRewardsStatusCheckFailure,

  [LoyaltyDetailsTypes.GET_LOYALTY_PROMOTIONS_LOADING]: getLoyaltyPromotionsLoading,
  [LoyaltyDetailsTypes.GET_LOYALTY_PROMOTIONS_SUCCESS]: getLoyaltyPromotionsSuccess,
  [LoyaltyDetailsTypes.GET_LOYALTY_PROMOTIONS_FAILURE]: getLoyaltyPromotionsFailure,

  [LoyaltyDetailsTypes.ACTIVATE_LOYALTY_PROMOTIONS_LOADING]: activateLoyaltyPromotionsLoading,
  [LoyaltyDetailsTypes.ACTIVATE_LOYALTY_PROMOTIONS_SUCCESS]: activateLoyaltyPromotionsSuccess,
  [LoyaltyDetailsTypes.ACTIVATE_LOYALTY_PROMOTIONS_FAILURE]: activateLoyaltyPromotionsFailure,

  [LoyaltyDetailsTypes.GET_LOYALTY_GAME_DATA_LOADING]: getLoyaltyGameDataLoading,
  [LoyaltyDetailsTypes.GET_LOYALTY_GAME_DATA_SUCCESS]: getLoyaltyGameDataSuccess,
  [LoyaltyDetailsTypes.GET_LOYALTY_GAME_DATA_FAILURE]: getLoyaltyGameDataFailure,

  [LoyaltyDetailsTypes.UPDATE_LOYALTY_GAME_DATA_LOADING]: updateLoyaltyGameDataLoading,
  [LoyaltyDetailsTypes.UPDATE_LOYALTY_GAME_DATA_SUCCESS]: updateLoyaltyGameDataSuccess,
  [LoyaltyDetailsTypes.UPDATE_LOYALTY_GAME_DATA_FAILURE]: updateLoyaltyGameDataFailure,

  [LoyaltyDetailsTypes.CLEAN_LOYALTY_DETAILS_STATE]: cleanLoyaltyDetailsState,
  [LoyaltyDetailsTypes.CLEAN_LOYALTY_PROMOTIONS_STATE]: cleanLoyaltyPromotionsState
});
